import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

const MobileRevealButton = styled(IconButton)(
  {
    color: 'rgba(255, 255, 255, 0.6)',
    '.MuiSvgIcon-root': {
      width: 32,
      height: 32,
    },
  },
  addHighContrastStyles({
    color: 'white',
    backgroundColor: 'black',
    borderRadius: 4,
    ':hover, :focus': {
      backgroundColor: 'black',
    },
  }),
);

export default MobileRevealButton;
